import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
    hotelsData: [],
    hotels: [],
    hotelRates: [],
    hotelImages: null,
    detailId: null,
    detailsData: null,
    detailContent: null,
    detailName: null,
    detailRates: null,
    detailStar: 0,
    preferences: null,
    detailDescription: null,
    importantLandmarks: null,
    popularLandmarks: null,
    landmarks: null,
    amenities: null,
    groupedAmenities: null,
    selectedAmenity: null,
    checkIn: null,
    checkOut: null,
    loading: true,
    revisedDataLoading: true,
    reviewData: null,
    reviewStar: null,
    reviewAddress: null,
    reviewCity: null,
    guests: [],
    rooms: 0,
    paxCounter: 0,
    paxID: 1,
    reviewPinCode: null,
    reviewImageURL: null,
    reviewFareBreakUp: null,
    reviewCheckIn: null,
    reviewCheckOut: null,
    reviewInclusions: null,
    reviewCancellationPolicies: null,
    reviewPriceId: null,
    detailLoading: true,
    reviewLoading: true,
    tripInfo: null,
    extendedTripInfo: null,
    roomGuests: [
        {
            guestDetails: [
                {
                    guestType: 'Adult',
                    salutation: 'Mr',
                    firstName: '',
                    middleName: '',
                    lastName: '',
                }
            ]
        },
        {
            guestDetails: [
                {
                    guestType: 'Adult',
                    salutation: 'Mr',
                    firstName: '',
                    middleName: '',
                    lastName: '',
                }
            ]   
        }
    ]
}

const reducer = (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.SET_LOADING:
            return updateObject(state, {loading: true})
        case actionTypes.SET_REVISED_DATA_LOADING:
            return updateObject(state, {revisedDataLoading: true})
        case actionTypes.SET_DETAIL_LOADING:
            return updateObject(state, { detailLoading: true })
        case actionTypes.SET_REVIEW_LOADING:
            return updateObject(state, {
                reviewLoading: true,
            })
        case actionTypes.SET_HOTELS:
            // let hotels = state.hotels;
            // let hotelsData = state.hotelsData;
            // let hotelRates = state.hotelRates;
            // hotels = state.hotels.concat(action.hotelsData.content.hotels);
            // hotelsData = state.hotelsData.concat(action.hotelsData);
            // hotelRates = state.hotelRates(action.hotelsData.rates.hotels);
            return updateObject(state, {
                hotelsData: action.hotelsData,
                hotels: action.hotelsData.content.hotels,
                hotelRates: action.hotelsData.rates.hotels,
                loading: false,
                revisedDataLoading: false
            })
        case actionTypes.SET_HOTEL_DETAILS:
            console.log(action.detailsData);
            console.log(action.detailsData.content);
            let landmarks = null;
            let importantLandmarks = null;    
            let popularLandmarks = null;
            let detailRates = null;
            let preferences = [];
            let detailContent = null;
            let hotelImages = null;
            let amenities = null;
            
            detailContent = action.detailsData.content;
            hotelImages = detailContent.images;

            //Logic for Room Preference
            detailRates = action.detailsData.rates;
            for(let i = 0; i < detailRates.length; i++) {
                let elementFound = false;
                if(preferences.length === 0) {
                    preferences.push([detailRates[i]]);
                } else {
                    for(let j = 0; j < preferences.length; j++) {
                        if(preferences[j][0].roomDesc === detailRates[i].roomDesc) {
                            elementFound = true;
                            preferences[j].push(detailRates[i]);
                            break;
                        }
                    }
                    if(!elementFound) {
                        preferences.push([detailRates[i]]);
                    }
                } 
            }

            // Logic for LandMarks
            if(action.detailsData.content.landmarks) {
                landmarks =  action.detailsData.content.landmarks;
            }

            if (action.detailsData.content.nCtgs) {
                if(action.detailsData.content.nCtgs.Important_Landmark) {
                    importantLandmarks = action.detailsData.content.nCtgs.Important_Landmark;
                }
                if(action.detailsData.content.nCtgs.Most_Popular_Landmark) {
                    popularLandmarks = action.detailsData.content.nCtgs.Most_Popular_Landmark;
                }
            }

            // Logic for grouped amenities
            amenities = action.detailsData.content.amenities;
            let groupedAmenities = [];

            for(let i = 0; i < amenities.length; i++) {
                let elementFound = false;
                if(groupedAmenities.length === 0) {
                    groupedAmenities.push([amenities[0]]);
                } else {
                    for (let j = 0; j < groupedAmenities.length; j++) {
                        if(groupedAmenities[j][0].category === amenities[i].category) {
                            elementFound = true;
                            groupedAmenities[j].push(amenities[i]);
                            break;
                        }
                    }
                    if(!elementFound) {
                        groupedAmenities.push([amenities[i]]);
                    }
                }
            }
            const selectedAmenity = groupedAmenities[0][0].category;

            return updateObject(state, {
                detailsData: action.detailsData,
                detailId: action.detailsData.detailId,
                hotelImages: hotelImages,
                detailContent: detailContent,
                detailName: action.detailsData.content.name,
                detailRates: action.detailsData.rates,
                detailStar: action.detailsData.content.star,
                landmarks: landmarks,
                detailDescription: action.detailsData.content.description,
                importantLandmarks: importantLandmarks,
                popularLandmarks: popularLandmarks,
                preferences: preferences,
                amenities: amenities,
                groupedAmenities: groupedAmenities,
                selectedAmenity: selectedAmenity,
                checkIn: action.detailsData.content.checkIn,
                checkOut: action.detailsData.content.checkOut,
                detailLoading: false,
                tripInfo: action.detailsData.content.tripInfo,
                extendedTripInfo: action.detailsData.content.extendedtripInfo
            })
        case actionTypes.SET_SELECTED_AMENITY:
            return updateObject(state, {
                selectedAmenity: action.selectedAmenity
            })

        case actionTypes.SET_HOTEL_REVIEW_DETAILS:
            return updateObject(state, {
                reviewData: action.reviewData,
                reviewStar: action.reviewData.content.star,
                reviewHotelName: action.reviewData.content.name,
                reviewAddress: action.reviewData.content.address.addressFormated,
                reviewCity: action.reviewData.content.address.city,
                reviewPinCode: action.reviewData.content.address.pincode,
                reviewImageURL: action.reviewData.content.defaultImages.url,
                reviewFareBreakUp: action.reviewData.rate.fareBreakup,
                reviewCheckIn: action.reviewData.content.checkInTime,
                reviewCheckOut: action.reviewData.content.checkOutTime,
                reviewInclusions: action.reviewData.rate.inclusions,
                reviewCancellationPolicies: action.reviewData.rate.cancellationPolicies,
                reviewPriceId: action.reviewData.priceId,
                rooms: action.rooms,
                paxCounter: action.rooms,
                reviewLoading: false
            })
        case actionTypes.ADD_HOTEL_PAX:
            const hotelGuest = {
                paxID: state.paxID,
                guestDetails: [
                    {
                        salutation: action.title,
                        firstName: action.firstName,
                        lastName: action.lastName,
                        guestType: "Adult",
                        passengerClass: "ADT"
                    }
                ],
                isSelected: action.isSelected
            }
            const oldGuests = [...state.guests];
            const updatedGuests = oldGuests.concat(hotelGuest);
            return {
                ...state,
                guests: updatedGuests,
                paxCounter: parseInt(state.paxCounter, 10) - 1,
                paxID: state.paxID + 1
            }
        case actionTypes.TOGGLE_HOTEL_PAX:
            let updatedPaxCount = state.paxCounter;
            const selectedGuest = state.guests.filter(guest => guest.paxID === action.id);
            const selectedGuestCopy = JSON.parse(JSON.stringify(selectedGuest[0]));
            selectedGuestCopy.isSelected = !selectedGuest[0].isSelected;

            if (!selectedGuestCopy.isSelected) {
                updatedPaxCount += 1;
            } else {
                updatedPaxCount -= 1;
            }
            const guests = JSON.parse(JSON.stringify(state.guests));
            const index = state.guests.findIndex(guest => guest.paxID === action.id);
            guests[index] = selectedGuestCopy;

            return {
                ...state,
                guests: guests,
                paxCounter: updatedPaxCount
            }

        case actionTypes.EDIT_HOTEL_PAX:
            console.log("Edit pax called")
            return {
                ...state
            }
        case actionTypes.SET_UPDATE_MARKUP:
            return updateObject(state, {
                reviewFareBreakUp: action.markupData.fareBreakup
            })
        default:
            return state;
    }
}

export default reducer;


// WEBPACK FOOTER //
// ./src/store/reducers/hotels.js